module.exports = __webpack_public_path__ + "media/images/icon__checkmark@3x-1d76ce18845fcb7aa9e84be41a652559.png";